<template>
  <button
    :disabled="disabled"
    @click.stop="$emit('click', $event)"
    class="flex flex-col items-center justify-center bg-transparent border-none cursor-pointer text-highlight hover:underline disabled-class"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      class="w-6 h-6 mb-1"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
      />
    </svg>
    <slot>
      <span class="text-xs font-bold">Reprint</span>
    </slot>
  </button>
</template>

<script>
export default {
  props: {
    disabled: { type: Boolean, default: false },
  },
};
</script>

<style lang="postcss" scoped>
.disabled-class:disabled,
.disabled-class[disabled] {
  @apply text-gray cursor-not-allowed no-underline;
}
</style>
